import { arrayOf, objectOf } from "@altostra/type-validations";
import { number, string } from "@altostra/type-validations/lib/primitives";

import type { GetDecisioningStudioAgentsAppGroupIdDsaIdCreativeComponentsResult } from "./types";

export const isGetDecisioningStudioAgentsAppGroupIdDsaIdCreativeComponentsResult =
  objectOf<GetDecisioningStudioAgentsAppGroupIdDsaIdCreativeComponentsResult>({
    results: arrayOf(objectOf({ component: string, type: string, activeVariantCount: number })),
  });
